import {useTranslation} from "react-i18next";
import { PROCURER_STATUS_DISMISSED, PROCURER_STATUS_READY } from "./Constants";

export const useStatusValuesProcurer = () => {
    const {t} = useTranslation(['salesmarketing']);

    const getStatusLabelProcurer = (status: string) => {
        switch (status) {
            case PROCURER_STATUS_READY: return t('salesmarketing:procurer.statusValues.ready');
            case PROCURER_STATUS_DISMISSED: return t('salesmarketing:procurer.statusValues.dismissed');
            default: return "";
        }
    };

    return {
        getStatusLabelProcurer
    }
}